const RestrictionsDecorate = require('../../../../facade/restrictions/decorate');

module.exports = RestrictionsDecorate({
  haveOptions: function (selection) {
    const restrictionsFacade = require('../../../../facade/restrictions/restrictions');
    const getRestrictions = _.partial(
      restrictionsFacade.getElementRestrictions,
      selection.id
    );

    const basicRestrictions = getRestrictions('basic');
    if (!basicRestrictions[0] || _.isUndefined(basicRestrictions[0].image_content)) {
      basicRestrictions[0] = restrictionsFacade.getAllDefaultPermissions();
    }

    const canReplace = basicRestrictions[0].image_content;

    return canReplace;
  }
}, { haveOptions: function () { return false; } });
